import React, { useEffect, useState } from "react";
import { UsersFour, Copy, CheckCircle, ArrowRight } from "@phosphor-icons/react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function ReferralCard() {
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    api.get("/referrals/me").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;
  const url = `${window.location.origin}/signup?ref=${data.code}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Referral link copied");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Copy failed — long-press to select.");
    }
  };

  return (
    <div className="bg-zinc-900/60 border border-zinc-800 rounded-sm p-5 lg:col-span-2" data-testid="referral-card">
      <div className="flex items-center gap-2 mb-2">
        <UsersFour size={16} weight="duotone" className="text-orange-500" />
        <div className="font-display font-medium text-zinc-100">Refer a friend · give 30 days, get 30 days</div>
      </div>
      <p className="text-xs text-zinc-500 mb-4">
        Share your link. When someone signs up and upgrades to Pro, you both get {data.credit_days} free days added to your subscription.
      </p>

      <div className="flex items-stretch gap-2 mb-4">
        <div className="flex-1 bg-zinc-950 border border-zinc-800 rounded-sm px-3 py-2 font-mono text-xs text-zinc-300 truncate" data-testid="referral-url">
          {url}
        </div>
        <button
          onClick={copy}
          data-testid="referral-copy-btn"
          className="inline-flex items-center gap-1.5 bg-orange-600 hover:bg-orange-500 text-zinc-950 font-medium rounded-sm px-4 text-sm"
        >
          {copied ? <><CheckCircle size={14} weight="fill" /> Copied</> : <><Copy size={14} weight="bold" /> Copy</>}
        </button>
      </div>

      <div className="grid grid-cols-3 gap-3 border-t border-zinc-800/60 pt-3">
        <div>
          <div className="text-[10px] font-mono uppercase tracking-wider text-zinc-500">Code</div>
          <div className="text-sm text-zinc-100 font-mono mt-0.5" data-testid="referral-code">{data.code}</div>
        </div>
        <div>
          <div className="text-[10px] font-mono uppercase tracking-wider text-zinc-500">Signups pending</div>
          <div className="text-sm text-zinc-100 mt-0.5" data-testid="referral-pending">{data.pending}</div>
        </div>
        <div>
          <div className="text-[10px] font-mono uppercase tracking-wider text-zinc-500">Days earned</div>
          <div className="text-sm text-emerald-400 mt-0.5" data-testid="referral-earned">+{data.total_days_earned}</div>
        </div>
      </div>
    </div>
  );
}
